'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-1887e1af.js');
var React = require('react');
var styled = require('styled-components');
var components_Body2_index = require('../Body2/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

// mui v5 overrides styles, so !important is needed
var Container = styled__default["default"].li(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start !important;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start !important;\n"])));
var Header = styled__default["default"](components_Body2_index["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject([""], [""])));
var Subheader = styled__default["default"](components_Body2_index["default"])(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var secondary = _a.theme.colors.text.secondary;
    return secondary;
});
// "...rest" is needed because MUI passes an arbitrary set of props to the
// component for styling, functionality, etc
var Option = function (_a) {
    var children = _a.children, subheader = _a.subheader, rest = tslib_es6.__rest(_a, ["children", "subheader"]);
    return (React__default["default"].createElement(Container, tslib_es6.__assign({}, rest),
        React__default["default"].createElement(Header, null, children),
        subheader && React__default["default"].createElement(Subheader, null, subheader)));
};
var templateObject_1, templateObject_2, templateObject_3;

exports["default"] = Option;
